module.exports = __webpack_public_path__ + "img/99_status4.a52c1bef.gif";